import React from 'react';
import ImportUsers from '../../Components/Users/ImportUsers';
import { ToastContainer } from 'react-toastify';
import { usePermission } from '../../hooks/usePermission';
import { CreateUser } from '../../Components/Users/CreateUser';

export default function CreateUsers() {
  const { data: canImportUsers } = usePermission({
    permissionName: 'ImportUsers'
  });
  return (
    <div className="container mx-auto px-4 py-8">
      <ToastContainer />
      <h2 className="text-3xl font-bold text-gray-800">Create New User</h2>
      <div className="flex justify-end items-center mb-6">
        {canImportUsers && (
          <ImportUsers />
        )}
      </div>
      <div className="bg-white rounded-lg shadow-lg p-6">
        <CreateUser />
      </div>
    </div>
  );
};